/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  INITIATE_UPDATE_TRACE_STEP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.updateTraceStep',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_UPDATE_TRACE_STEP' },
      },
    },
    INITIATE_UPDATE_TRACE_STEP: {
      invoke: {
        id: 'updateTraceStep',
        src: 'updateTraceStep',
        onDone: {
          target: 'UPDATE_TRACE_STEP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'UPDATE_TRACE_STEP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    UPDATE_TRACE_STEP_SUCCESS: {
      on: {
        MUTATE: { target: 'INITIATE_UPDATE_TRACE_STEP' },
      },
    },
    UPDATE_TRACE_STEP_ERROR: {
      on: {
        MUTATE: { target: 'INITIATE_UPDATE_TRACE_STEP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
